import Route from './route.js';
import RouteMarker from '../markers/route-marker.js';

export default class SpeedRoute extends Route {
    constructor(routeInfo, map, colorIndex, hideIcons, playbackIcon, disableRouteMarkers, fullRouteInfo) {
        super(routeInfo, map, colorIndex, hideIcons, playbackIcon, disableRouteMarkers, fullRouteInfo);
    };

    _createLayer() {
        let multiOptions = this._makeMultiOptionsObject();
        let colorPolyline = L.multiOptionsPolyline(this.coordsArray, {
            multiOptions: multiOptions,
            weight: this.config.routeLine.width,
            lineCap: 'round',
            interactive: false,
            opacity: 1,
            smoothFactor: 1
        });

        return colorPolyline;
    };

    _createRouteMarker(point) {
        let color = 'red';
        for (let i = 0; i < this.speedThresholds.length; i++) {
            if (point.speed <= this.speedThresholds[i]) {
                color = this.speedColors[i];
                break;
            }
        }
        return new RouteMarker(this.map, point, this.route.oid, this.allDistance, color);
    };

    _makeMultiOptionsObject() {
        let multiopts = {
            optionIdxFn: (latLng) => {
                var i;
                var speedThresholds = [40, 60, 90];
                for (i = 0; i < speedThresholds.length; i++) {
                    if (latLng[2] <= speedThresholds[i]) {
                        return i;
                    }
                }
                return speedThresholds.length;
            },
            options: [
                { color: 'green' },
                { color: 'lightgreen' },
                { color: 'yellow' },
                { color: 'red' }]
        };
        return multiopts;
    };

    _fillCoordsArray(point) {
        this.coordsArray.push([point.lat, point.lon, point.speed]);
    };

    reduceIndex(index) {
        return index;
    };
}
